import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import ErrorBoundary from './components/layout/ErrorBoundary.jsx'
import './index.css'

const rootElement = document.getElementById('root')

// --- CHUNK LOAD ERROR RECOVERY ---
// Triggers a hard reload if a user navigates to a lazy-loaded route after a new deployment
// has replaced the old hashed JS chunks on the server.
window.addEventListener('error', (e) => {
  if (e.message?.includes('Failed to fetch dynamically imported module') || 
      e.message?.includes('Importing a transcompiled module is not supported')) {
    window.location.reload();
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});

// React Hydration / Mounting
// react-snap pre-renders each page for LCP + SEO.
// We use createRoot (not hydrateRoot) because framer-motion animations
// (navbar sliding from y:-100%, hero elements at opacity:0) create
// unavoidable hydration mismatches. React mounts cleanly over the
// pre-rendered snapshot — crawlers see full HTML, users get fast first paint.
createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)

// Signal to the index.html shell that we are ready to unveil
if (typeof window.markAppReady === 'function') {
  window.markAppReady();
}



